import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';
import useAuth from '../../hooks/global/useAuth';
import useAppMethods from '../../hooks/utility/useAppMethods';

interface Props {
  className?: string;
}

export default function CashbackProgramBanner({ className }: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Cashback:CashbackProgramBanner' });

  const { isLoggedIn } = useAuth();
  const { hasCashbackProgram, cashbackProgram, calculateMinAmountForExpectedCashback } = useCashbackProgram();
  const { formatCurrency, toggleLoginModal } = useAppMethods();

  if (!hasCashbackProgram || isLoggedIn) {
    return null;
  }

  const onJoinClick = () =>
    toggleLoginModal({
      openModal: true,
      onCloseRedirect: () => null,
    });

  const programName = cashbackProgram?.title ?? t('default_program_name');
  const reward = formatCurrency(5);
  const spend = formatCurrency(calculateMinAmountForExpectedCashback(5));

  return (
    <div className={classnames(bannerContainer, className)}>
      <div className="flex items-center gap-sm min-w-0">
        <Star className="w-5 h-5 fill-brand-primary text-brand-primary shrink-0" />
        <p className="text-sm text-brand-text-primary">
          <Trans
            t={t}
            values={{ name: programName, reward, spend }}
            components={{ highlight: <span className="font-semibold" /> }}
          >
            message
          </Trans>
        </p>
      </div>
      <button type="button" onClick={onJoinClick} className={joinButton}>
        {t('buttons.join_now')}
      </button>
    </div>
  );
}

const bannerContainer =
  'flex flex-col sm:flex-row sm:items-center justify-between gap-sm rounded-xl border-xs border-brand-primary/20 bg-brand-primary/10 px-md py-sm';

const joinButton =
  'shrink-0 text-sm font-semibold border-xs border-brand-border rounded-full px-md py-xs text-brand-text-primary bg-brand-card hover:bg-muted transition-colors whitespace-nowrap';
